/**
 * Add custom styles to List block.
 */
const ListOverrides = () => {
  wp.blocks.registerBlockStyle('core/list', {
    name: 'default',
    label: 'Default',
    isDefault: true,
  });

  wp.blocks.registerBlockStyle('core/list', {
    name: 'inline',
    label: 'Inline',
  });
};

export default ListOverrides;
